<template>
  <div class="details">
    <div class="all-title">
      {{title}}
    </div>
    <div class="content" v-if="pageData">
      <div class="info">
        <span class="time">{{pageData.time}}</span>
        <span class="label">{{pageData.label}}</span>
      </div>
      <h1 class="newsTitle">{{pageData.title}}</h1>
      <div class="news" v-html="pageData.content"></div>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        resDatas:'',
        num:8,
        page:1,
        allpage:''
      }
    },
    computed: {
      title() {
        return this.$store.state.languagesData.news.title;
      },
      pageData(){
        return this.$store.state.detailData;
      }
    },
    methods:{

    },
    mounted() {
      console.log(1111)
      this.$store.commit("highLighted","news");
      this.$store.dispatch('getDetail',this.$route.query.id);
    }
  }
</script>

<style scoped>
  .content{
    margin: auto;
    max-width: 750px;
    box-sizing: border-box;
  }
  .info{
    font-size: 0;
    color: black;
  }
  .time{
    font-size: 14px;
    display: inline-block;
    vertical-align: middle;
  }
  .label{
    font-size: 16px;
    padding:0 5px;
    display: inline-block;
    vertical-align: middle;
    background-color: #536E7A;
    color: white;
    margin-left: 10px;
  }
  .newsTitle{
    color: #555;
    padding: 0 5%;
    font-size: 30px;
    margin-top: 35px;
    text-align: center;
  }
  .news{
    margin-top: 35px;
    color: #555;
    font-size: 18px;
  }
  @media screen and (max-width: 1000px){
    .content{
      padding: 0 4%;
    }
    .newsTitle{
      font-size: 20px;
    }
    .news{
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/details.vue